
export const ProfileLoading = () => {
  return (
    <div className="bg-card backdrop-blur-lg rounded-xl p-6 border border-border transition-colors duration-300">
      <div className="flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    </div>
  );
};
